import { AbsenceStateTypes, AbsenceActionTypes } from "./Absence.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AbsenceStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AbsenceReducer = (
  state: AbsenceStateTypes = INITIAL_STATE,
  action: any
): AbsenceStateTypes => {
  switch (action.type) {
    case AbsenceActionTypes.FETCH_ALL_ABSENCE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AbsenceActionTypes.FETCH_ALL_ABSENCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AbsenceActionTypes.FETCH_ALL_ABSENCE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AbsenceActionTypes.FETCH_ALL_ABSENCE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AbsenceActionTypes.FETCH_ONE_ABSENCE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AbsenceActionTypes.FETCH_ONE_ABSENCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AbsenceActionTypes.FETCH_ONE_ABSENCE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AbsenceActionTypes.FETCH_ONE_ABSENCE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AbsenceReducer;
